import React from 'react';
import * as S from './QuestionHeader.styles';
import { useTranslation } from 'react-i18next';

interface IQuestionHeaderProps {
  orderId: string;
  difficulty: string;
  type: string;
}

export const QuestionHeader: React.FC<IQuestionHeaderProps> = React.memo(({ orderId, difficulty, type }) => {
  const { t } = useTranslation();
  return (
    <S.Wrapper>
      <div>
        <S.QuestionNum>{orderId}</S.QuestionNum>
      </div>
      <div className="text-base font-semibold">
        {/* {convertQuestionByType(type)} */}
        {t(`pteSection.${type}`)}
      </div>
      <div className="flex gap-4">
        {difficulty && <S.Tag difficulty={difficulty}>{difficulty}</S.Tag>}
        {/* <div className="cursor-pointer">
          <BookmarkIcon />
        </div> */}
      </div>
    </S.Wrapper>
  );
});
